export default {
  SET_SETTINGS (state, settings) {
    state.api = settings.apiUrl || ''
    state.version = settings.version || ''
    state.appName = settings.appName || ''
    state.appEmail = settings.appEmail || ''
    state.notificationsLoop = settings.notificationsLoop || 10000
    state.notificationsSocket = settings.notificationsSocket || 'wss://app.kolyom.co.il:8443'
  },
  SET_API_URL (state, api) {
    state.api = api
  },
  SET_APP_VERSIONS (state, serverVersions) {
    state.serverVersions = serverVersions
  },
  SET_APP_NAME (state, name) {
    state.appName = name
  },
  SET_APP_EMAIL (state, email) {
    state.appEmail = email
  }
}



// WEBPACK FOOTER //
// ./src/store/settings/mutations.js